import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { injectTranslate } from '@core/i18n-legacy';
import { InviteMethod } from '@core/tellent-types';
import {
  BadgeComponent,
  IconComponent,
  InputComponent,
  OverlayOriginDirective,
  SelectComponent,
} from '@core/user-interface-legacy';

interface InviteMethodOption {
  value: InviteMethod;
  label: string;
  heading: string;
  subheading: string;
  badgeText?: string;
}

@Component({
  selector: 'tlc-invite-method-select',
  templateUrl: './invite-method-select.component.html',
  styleUrl: './invite-method-select.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    InputComponent,
    OverlayOriginDirective,
    IconComponent,
    BadgeComponent,
    SelectComponent,
    ReactiveFormsModule,
  ],
})
export class InviteMethodSelectComponent {
  private readonly t = injectTranslate();

  public inviteMethodControl = input.required<FormControl<InviteMethod | null>>();

  public options: InviteMethodOption[] = [
    {
      value: InviteMethod.Email,
      label: this.t(
        'tlc.members.add_member.member_details_form.invite_method.dropdown.email.label',
      ),
      heading: this.t(
        'tlc.members.add_member.member_details_form.invite_method.dropdown.email.heading',
      ),
      subheading: this.t(
        'tlc.members.add_member.member_details_form.invite_method.dropdown.email.subheading',
      ),
    },
    {
      value: InviteMethod.Login,
      label: this.t(
        'tlc.members.add_member.member_details_form.invite_method.dropdown.login.label',
      ),
      heading: this.t(
        'tlc.members.add_member.member_details_form.invite_method.dropdown.login.heading',
      ),
      subheading: this.t(
        'tlc.members.add_member.member_details_form.invite_method.dropdown.login.subheading',
      ),
      badgeText: this.t(
        'tlc.members.add_member.member_details_form.invite_method.dropdown.login.badge',
      ),
    },
  ];
}
